export default class ProjectCompany {
  public constructor(public id: number, public name: string) {}
}
